import { render, staticRenderFns } from "./AthleteVerifiedAssessmentSummary.vue?vue&type=template&id=70a4d688&scoped=true&"
import script from "./AthleteVerifiedAssessmentSummary.vue?vue&type=script&lang=ts&"
export * from "./AthleteVerifiedAssessmentSummary.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteVerifiedAssessmentSummary.vue?vue&type=style&index=0&id=70a4d688&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a4d688",
  null
  
)

export default component.exports